import React from "react";

interface StaticTextFieldProps {
  value?: string;
}

const StaticTextField = (props: StaticTextFieldProps) => {
  const { value } = props;
  return <div className="dui-field-static-text">{value}</div>;
};

export default StaticTextField;
